<template>
    <div class="user-room" data-app>
      <v-toolbar color="primary" class="chat-room--toolbar" flat dark dense>
        <v-spacer></v-spacer>
        <v-menu offset-y>
           <v-btn @click="download"  depressed
            slot="activator"  color="primary" dark>
            Download settings
          </v-btn>
          <v-btn @click="dashBoard"  depressed
            slot="activator"  color="primary" dark>
            Dashboard
          </v-btn>
        </v-menu>
        <v-btn icon @click="reload">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn icon @click="handleFullScreen()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn icon @click="logout()">
          <v-icon>exit_to_app</v-icon>
        </v-btn>
      </v-toolbar> 

      <template>
        <template v-if="this.materialGrp == 'new'">
            <v-btn small round @click="save">
          create
        <v-icon small right>
          create
        </v-icon>
        </v-btn>
        </template>
        <template v-else>

        <v-btn small round @click="save">
          Save
        <v-icon small right>
          save
        </v-icon>
        </v-btn>
        </template>
      </template>

      <template>

        
        <vue-perfect-scrollbar class="chat-history--scrollbar">

        <table>              
                <tr>
                  <td><b>MaterialGrp</b> - Warengruppe</td>
                  <td><v-text-field height="15px" v-model="msgkItem.materialGrp" required="required"></v-text-field></td>
                </tr>             
          
         <tr>
           <td><b>GeneralAgreement</b> - Dürfen Rahmenverträge verhandelt werden?</td>
           <td>
              <v-select height="15px" :items="generalAgreementOptions" v-model="msgkItem.generalAgreement">
              </v-select>
            </td>
          </tr>
          <tr>
            <td><b>MinShoppingCartValue</b> - Unterer Grenzbetrag des Gesamtswerts &nbsp; &nbsp;</td>
             <td>
              <v-text-field height="15px" v-model="msgkItem.minShoppingCartValue" type="number" @keypress="isNumber($event)">
              </v-text-field>
            </td>
         </tr>
         <tr>
              <td><b>MaxShoppingCartValue</b> - Oberer Grenzbetrag des Gesamtswerts</td>
               <td>
              <v-text-field height="15px" v-model="msgkItem.maxShoppingCartValue" type="number" @keypress="isNumber($event)">
              </v-text-field>
            </td>
           </tr>
         <tr>
              <td><b>Team</b> - Team</td>
               <td>
              <v-select height="15px" :items="teamOptions" v-model="msgkItem.team">
              </v-select>
            </td>
          </tr>
         <tr>
              <td><b>ErrorEKG</b> - Einkäufergruppe der Warengruppe</td>
              <td>
              <v-text-field height="15px" v-model="msgkItem.errorEKG" required="required" type="number" @keypress="isNumber($event)">
              </v-text-field>
            </td>
          </tr>
         <tr>
              <td><b>StartingPrice</b> - Nelsons Startpreis in %</td>
               <td>
              <v-text-field height="15px" v-model="msgkItem.startingPrice" required="required" type="number" @keypress="isNumber($event)">
              </v-text-field>
            </td>
          </tr>
         <tr>
              <td><b>TargetPrice</b> - Nelsons Mindestakzeptanzpreis in %</td>
               <td>
              <v-text-field height="15px" v-model="msgkItem.targetPrice" required="required" type="number" @keypress="isNumber($event)">
              </v-text-field>
            </td>
          </tr>
         <tr>
              <td><b>LinkValidity</b> - Gültigkeit des Verhandlungslinks in Stunden</td>
               <td>
              <v-text-field height="15px" v-model="msgkItem.linkValidity" type="number" @keypress="isNumber($event)">
              </v-text-field>
            </td>
           </tr>
         <tr>
              <td><b>MaxIterations</b> - Max Anzahl an Verhandlungsrunden</td>
              <td>
              <v-text-field height="15px" v-model="msgkItem.maxIterations" type="number" @keypress="isNumber($event)">
              </v-text-field>              
            </td>
           </tr>
         <tr>
              <td><b>Negotiation Logic</b> - Verhandlungslogik</td>
               <td>
              <v-select height="15px" :items="negoOptions" v-model="msgkItem.negotiationLogic">
              </v-select>
            </td>
           </tr>
        </table>
        </vue-perfect-scrollbar>
      </template>
    </div>
</template>
<script>
import API from '@/api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VWidget from '@/components/VWidget'
import Util from '@/util'

export default {
  data: () => ({
    materialGrp: '',
    msgkItem: {},
    languageOptions: [
      "en", "de"
    ],
    generalAgreementOptions: ["yes", "no"],
    negoOptions : [],
    teamOptions : []
  }),
  mounted () {
    this.materialGrp = this.$route.params.materialGrp,
    this.getMsgkByMaterialGrp(),
    API.getNegoLogics().then(negoOptions  => {
      this.negoOptions = negoOptions;       
    });
    API.getTeams().then(teamOptions  => {
      this.teamOptions = teamOptions;      
    });
  },
   watch: {
    $route (to, from) {
      this.materialGrp = to.params.materialGrp
      this.getMsgkByMaterialGrp()
    }
  },
  components: {
    VWidget,
    VuePerfectScrollbar
  },
  props: {
    height: {
      type: String,
      default: null
    }
  },
  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      }
    },
    isAdmin() {
        if (localStorage.getItem("role") &&  localStorage.getItem("role").toLowerCase() === 'admin') {
          return true;
        } else {
          return false;
        }
      }
  },
  methods: {
    handleFullScreen () {
      Util.toggleFullScreen()
    },
    reload () {
      window.location.reload()
    },
    logout () {
      window.getApp.$emit('APP_LOGOUT')
    },
    dashBoard(){
      this.$router.push('/chat/messaging')
    },
    async download(){
      await API.exportMsgk();
    },
    async getMsgkByMaterialGrp () {
      console.log(this.materialGrp);
      if (this.materialGrp && this.materialGrp != "new") {
        this.msgkItem = await API.getMsgkByMaterialGrp(this.materialGrp);
      } else if(this.materialGrp == "new") {
        
        let teamValue = "";
        if(this.teamOptions.length > 0) {
          teamValue = this.teamOptions[0];
          console.log(teamValue);
        }
        this.msgkItem = { defaultLanguage: "de", generalAgreement: "yes", minShoppingCartValue : 1000, maxShoppingCartValue: 100000, team: teamValue, startingPrice: 90,
          targetPrice: 98, linkValidity: 48, maxIterations: 3, negotiationLogic: "oin_simple"
        }
      }
    },
    async save(){
      try{
        if(this.msgkItem.startingPrice > 99 || this.msgkItem.startingPrice < 50) {
          alert("invalid starting price");
        } else if(this.msgkItem.targetPrice > 99 || this.msgkItem.targetPrice < 50) {
          alert("invalid starting price");
        } else if(this.msgkItem.startingPrice > this.msgkItem.targetPrice ) {
          alert("Target price must be highier then starting price");
        } else if(this.msgkItem.maxIterations > 10 ) {
          alert("Maximum iteration is 10");
        } else{
          let password = prompt("Please enter your password:", "");
          console.log(password);
          let msgkItemExist = await API.getMsgkByMaterialGrp(this.msgkItem.materialGrp);
          if(this.materialGrp === "new") {
            if(msgkItemExist && msgkItemExist.materialGrp) {
              alert("Msgk already exist");
            } else {
              this.msgkItem.password = password;
              await API.addNewMsgk(this.msgkItem);
              alert("Created");
            }
          } else {
            this.msgkItem.oldMaterialGrp = this.materialGrp;
            if(this.msgkItem.oldMaterialGrp !== this.msgkItem.materialGrp && msgkItemExist && msgkItemExist.materialGrp) {
               alert("Msgk already exist");
            } else {
              this.msgkItem.password = password;
              await API.updateMsgk(this.msgkItem);
              alert("Saved");
            }
          }
        }

      }catch(e){
        this.msgkItem = await API.getMsgkByMaterialGrp(this.materialGrp);
      }
      
    },
    isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && (charCode != 9)) {
            evt.preventDefault();
        } else {
            return true;
        }
    }
  }
}
</script>